/**
 * @summary
 * <blockquote>Auto-generated resource types for RBAC system</blockquote>
 * 
 * @remarks
 * This file is auto-generated by @tools/generate-resource-types
 * Do not edit manually - changes will be overwritten.
 */

/**
 * @summary
 * <blockquote>Resource constants discovered from application structure</blockquote>
 **/
export const ACTION_RESOURCES = {
  DATA_TENANTS: 'data.tenants',
  DATA_USERS: 'data.users',
  DATA_ROLES: 'data.roles',
  DATA_PERMISSIONS: 'data.permissions',
  DATA_LEARNING: 'data.learning',
  AUTH_SIGNUP: 'auth.signup',
  DATA_TASKS: 'data.tasks',
  DATA_PROGRESS: 'data.progress',
  DATA_PHASES: 'data.phases',
  DATA_MODULES: 'data.modules',
  DATA_ANALYTICS: 'data.analytics',
} as const;